const Footer = () => (
	<footer id="footer" className="container-fluid">
		<p className="my-3 text-center">
			Icons made by <a href="https://www.flaticon.com/authors/freepik">Freepik</a> from{' '}
			<a href="https://www.flaticon.com/">www.flaticon.com</a>.
		</p>
	</footer>
);

export default Footer;
